var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_5361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.946 12.2242C23.946 11.2409 23.8662 10.5234 23.6935 9.7793H12.4656V14.2173H19.0561C18.9233 15.3202 18.2058 16.9811 16.6113 18.0972L16.5889 18.2458L20.139 20.996L20.3849 21.0205C22.6438 18.9344 23.946 15.8649 23.946 12.2242Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4654 23.9178C15.6943 23.9178 18.4049 22.8548 20.3848 21.0211L16.6111 18.0978C15.6013 18.8021 14.2459 19.2937 12.4654 19.2937C9.30302 19.2937 6.61896 17.2076 5.66217 14.3242L5.52192 14.3361L1.8305 17.193L1.78223 17.3271C3.74876 21.2337 7.78818 23.9178 12.4654 23.9178Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66235 14.3248C5.40989 13.5807 5.26378 12.7834 5.26378 11.9596C5.26378 11.1357 5.40989 10.3385 5.64907 9.59439L5.64238 9.43592L1.9047 6.5332L1.78241 6.59137C0.971905 8.21247 0.506836 10.0329 0.506836 11.9596C0.506836 13.8863 0.971905 15.7066 1.78241 17.3277L5.66235 14.3248Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4654 4.62403C14.711 4.62403 16.2257 5.59402 17.0895 6.40461L20.4645 3.10928C18.3917 1.1826 15.6943 0 12.4654 0C7.78818 0 3.74876 2.68406 1.78223 6.59056L5.64888 9.59359C6.61896 6.7102 9.30302 4.62403 12.4654 4.62403Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_5361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.231934)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconLogo);
export default __webpack_public_path__ + "static/media/google-icon-logo.819b353d0b46bf5d0a82b39e68663a99.svg";
export { ForwardRef as ReactComponent };